import React from 'react'

function Error404Page() {
  return (
    <div>Error404Page</div>
  )
}

export default Error404Page